module.exports = __webpack_public_path__ + "img/390-a3b047.png";